// Central place for platform-wide constants
export const PLATFORM_NAME = process.env.NEXT_PUBLIC_PLATFORM_NAME;
